import SectionHeader from "../common/SectionHeader";
import { acfList, acfText } from "../../utils/landingAcf";
import { SECTION_CONTAINER } from "../../utils/layout";
import "./LandingFeatures.css";

function FeatureItem({ feature, index }) {
  return (
    <li className="landing-features__item">
      <span className="landing-features__index" aria-hidden="true">
        {String(index + 1).padStart(2, "0")}
      </span>
      <span className="landing-features__check" aria-hidden="true">
        ✓
      </span>
      <p className="landing-features__text">{feature}</p>
    </li>
  );
}

function LandingFeatures({ acf }) {
  const title = acfText(acf.why_choose_title);
  const features = acfList(acf, "feature_", 7);

  if (!title && features.length === 0) return null;

  const primaryRow = features.slice(0, Math.min(4, features.length));
  const secondaryRow = features.slice(4);
  const primaryRowClass =
    primaryRow.length <= 3
      ? "landing-features__row landing-features__row--three"
      : "landing-features__row landing-features__row--four";

  return (
    <section className="caf-section caf-section--elevated landing-features">
      <div className="caf-section__block caf-section__block--spaced">
        {title ? (
          <SectionHeader title={title} showAccent centered titleId="landing-features-title" />
        ) : null}
        {features.length > 0 ? (
          <div
            className={`${SECTION_CONTAINER} landing-features__grid`}
            aria-labelledby={title ? "landing-features-title" : undefined}
          >
            <ul className={primaryRowClass}>
              {primaryRow.map((feature, index) => (
                <FeatureItem key={feature} feature={feature} index={index} />
              ))}
            </ul>
            {secondaryRow.length > 0 ? (
              <ul className="landing-features__row landing-features__row--three">
                {secondaryRow.map((feature, index) => (
                  <FeatureItem
                    key={feature}
                    feature={feature}
                    index={primaryRow.length + index}
                  />
                ))}
              </ul>
            ) : null}
          </div>
        ) : null}
      </div>
    </section>
  );
}

export default LandingFeatures;
